import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { Timer } from "@element-plus/icons-vue";
import MenuBox from "@/components/exam/MenuBox.vue";
import mm from "@/components/examItem/item-mm.vue";
import mm_drag from "@/components/examItem/item-mm-drag.vue";
import mm_mcq from "@/components/examItem/item-mm-mcq.vue";
import mcq_mmcq from "@/components/examItem/item-mcq-mmcq.vue";
import { reactive, ref, onBeforeUnmount, watch } from "vue";
import { useRoute } from "vue-router";
import { GetResumeApi, SubmitExamApi, SetResumeApi } from "@/api/examApi.js";
import { ElLoading, ElMessage, ElMessageBox } from "element-plus";
let examId = "";
let route;
export default {
  components: {
    MenuBox,
    mm,
    mcq_mmcq,
    mm_drag,
    mm_mcq
  },
  props: ["examInfo", "netState"],
  setup(props, content) {
    let paperInfo = reactive({});
    let itemNo = ref(0);
    let cache = reactive({});
    let totalQuestion = ref(0);
    let fastTime = ref(0);
    route = useRoute();
    examId = props.examInfo.examId + "";
    //试卷
    let {
      getPaper
    } = usePaper(paperInfo, totalQuestion, props.examInfo);
    //缓存
    let {
      getResume,
      setAnswer,
      setcache
    } = useAnswer(cache, getPaper, props.examInfo, itemNo, fastTime, props.netState, content);
    //流程
    let {
      timeText,
      setCountDown,
      finishExam,
      fastTimeText,
      setFastCountDown
    } = useExamProcess(props.examInfo, content, cache, setcache, totalQuestion, fastTime);
    getResume(setCountDown, setFastCountDown);
    watch(props.netState, () => {
      setCountDown();
    });
    return {
      Timer,
      finishExam,
      timeText,
      itemNo,
      paperInfo,
      cache,
      setAnswer,
      setcache,
      getPaper,
      fastTimeText,
      fastTime
    };
  }
};
//获取试卷
function usePaper(paperInfo, totalQuestion, examInfo) {
  //获取试卷
  function getPaper(id, setCountDown, setFastCountDown) {
    Object.assign(paperInfo, examInfo.papers[0]);
    totalQuestion.value = useSettingPaper(paperInfo, examInfo.subdivide);
    //倒计时
    setCountDown();
    //快速阅读
    if (examInfo.subdivide == 3 && (paperInfo.level == 5 || paperInfo.level == 6 || paperInfo.level == 7)) {
      paperInfo.items[0].isFast = true;
      if (setFastCountDown) setFastCountDown();
    }
  }
  return {
    getPaper
  };
}
//目录
function useSettingPaper(paperInfo, subdivide) {
  let task = 1;
  let taskNo = 0;
  if (subdivide == 3) {
    if (window.localStorage.getItem("preTotalNo-" + (route.query.examid || route.query.examId))) {
      task += Number(window.localStorage.getItem("preTotalNo-" + (route.query.examid || route.query.examId)));
    }
  }
  paperInfo.items.forEach(items => {
    items.skill = paperInfo.skill;
    items.menu = task;
    items.questionGroupList.forEach(group => {
      group.questionList.forEach(questionItem => {
        if (questionItem.questionScore) {
          task++;
          taskNo++;
        }
      });
    });
    //mm的分类
    if (items.questionGroupList[0].questionMethod == "mm") {
      //选择题展示
      if (items.questionGroupList[0].questionList[0].questionStem.split(" ").length > 2) {
        items.questionGroupList[0].questionMethod = "mm-mcq";
      } else if (items.questionGroupList[0].choiceList[0].choiceText.split(" ").length > 1) {
        items.questionGroupList[0].questionMethod = "mm-drag";
      }
    } else if (items.questionGroupList[0].questionMethod == "mcq") {
      items.questionGroupList.forEach(questionItem => {
        if (questionItem.choiceList.length == 2) {
          questionItem.questionMethod = "judge";
        }
      });
    }
  });
  return taskNo;
}
//缓存 答案
function useAnswer(cache, getPaper, examInfo, itemNo, fastTime, netState, content) {
  let setCacheTime = null;
  //获取缓存
  function getResume(setCountDown, setFastCountDown) {
    const loading = ElLoading.service({
      lock: true,
      text: "获取作答数据..",
      background: "rgba(0, 0, 0, 0.7)"
    });
    GetResumeApi(examId).then(r => {
      loading.close();
      if (r.status < 400) {
        Object.assign(cache, r.data);
        //题号
        if (cache.interruptMark) {
          cache.interruptMark = JSON.parse(cache.interruptMark);
          itemNo.value = cache.interruptMark.itemNo || 0;
          if (!examInfo.papers[0].items[itemNo.value]) itemNo.value = 1;
          fastTime.value = cache.interruptMark.fastTime || 15 * 60;
        } else {
          // itemNo.value = 0;
          fastTime.value = 15 * 60;
        }
        if (itemNo.value == 0) {
          getPaper(examInfo.paperIds[0], setCountDown, setFastCountDown);
        } else {
          getPaper(examInfo.paperIds[0], setCountDown);
        }
      } else {
        ElMessage({
          type: "error",
          showClose: true,
          message: r.msg
        });
      }
    });
  }
  //设置答案
  function setAnswer(msg) {
    for (let key in msg) {
      cache.answers[key] = msg[key];
    }
  }
  //设置缓存
  function setcache() {
    if (setCacheTime == cache.remaining) {
      return 0;
    } else {
      setCacheTime = cache.remaining;
    }
    let data = {
      answers: {
        ...cache.answers
      },
      audios: {
        ...cache.audios
      },
      remaining: cache.remaining,
      examId: examId,
      //题号
      interruptMark: {
        itemNo: itemNo.value,
        fastTime: fastTime.value
      }
    };
    if (netState) {
      window.localStorage.removeItem("cache-" + examId);
      SetResumeApi(data).then(r => {
        // if (r.status == 404) {
        //   ElMessage({
        //     type: "error",
        //     showClose: true,
        //     message: "您的考试已被强制提交。",
        //   });
        //   content.emit("finishExam");
        // } else
        if (r.status == 406) {
          ElMessage({
            type: "error",
            showClose: true,
            message: "您的考试已被重置。"
          });
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else if (r.status == 403) {
          ElMessage({
            type: "error",
            showClose: true,
            message: "您的登录已失效或在别处登录"
          });
          setTimeout(() => {
            window.closed();
          }, 2000);
        }
      });
    } else {
      data.interruptMark ? data.interruptMark = JSON.stringify(data.interruptMark) : "";
      window.localStorage.setItem("cache-" + examId, JSON.stringify(data));
    }
  }
  return {
    setAnswer,
    setcache,
    getResume
  };
}
//流程控制(倒计时，交卷)
function useExamProcess(examInfo, content, cache, setcache, totalQuestion, fastTime) {
  let countDownTimer;
  let fastCountDownTimer;
  let countTimer;
  let fastTimeText = ref("00:00");
  let timeText = ref("00:00:00");
  onBeforeUnmount(() => {
    if (countDownTimer) countDownTimer.close();
    countDownTimer = null;
    if (countTimer) clearInterval(countTimer);
  });
  //启动倒计时
  function setCountDown() {
    let time = cache.remaining || examInfo.remainingTime;
    //计时器
    countDownTimer = new WebSocket("wss://unilearn.fltrp.com/jzws/count-down");
    countDownTimer.onopen = () => {
      countDownTimer.send(time + ":1:" + examInfo.userId);
    };
    countDownTimer.onmessage = evt => {
      time = evt.data;
      if (time <= 0) {
        finishExam(2);
      } else {
        let s = time % 60;
        let m = parseInt(time / 60) % 60;
        let h = parseInt(parseInt(time / 60) / 60);
        timeText.value = `${h > 9 ? h : "0" + h}:${m > 9 ? m : "0" + m}:${s > 9 ? s : "0" + s}`;
        cache.remaining = time;
        //自动缓存(30s)
        if (time % 30 == 0) {
          setcache();
        }
        //倒计时提示
        if (time == 300) {
          ElMessage({
            type: "warning",
            showClose: true,
            message: "距离考试结束仅有5分钟"
          });
        }
      }
    };
    countDownTimer.onclose = e => {
      if (!e.wasClean && window.navigator.onLine && countDownTimer && countDownTimer.readyState != 0) {
        countDownTimer.close();
        setCountDown();
      }
    };
  }
  // function setCountDown() {
  //   if (countTimer) clearInterval(countTimer);
  //   let time = cache.remaining || examInfo.remainingTime;
  //   //计时器
  //   countTimer = setInterval(() => {
  //     time--;
  //     if (time <= 0) {
  //       finishExam(2);
  //     } else {
  //       let s = time % 60;
  //       let m = parseInt(time / 60) % 60;
  //       let h = parseInt(parseInt(time / 60) / 60);
  //       timeText.value = `${h > 9 ? h : "0" + h}:${m > 9 ? m : "0" + m}:${
  //         s > 9 ? s : "0" + s
  //       }`;
  //       cache.remaining = time;
  //       //自动缓存(30s)
  //       if (time % 30 == 0) {
  //         setcache();
  //       }
  //       //倒计时提示
  //       if (time == 300) {
  //         ElMessage({
  //           type: "warning",
  //           showClose: true,
  //           message: "距离考试结束仅有5分钟",
  //         });
  //       }
  //     }
  //   }, 1000);
  // }
  //倒计时验证

  //交卷(1手动交卷 2倒计时结束被交卷 3提交分卷)
  function finishExam(type) {
    if (type == 1) {
      //前置判断
      if (examInfo.totalTime - cache.remaining < 300) {
        ElMessageBox.confirm(`该部分作答五分钟后才可以提交`, "", {
          showClose: false,
          showCancelButton: false,
          cancelButtonText: false,
          type: "warning"
        });
        return 0;
      }
      //计算题目
      let questCount = 0;
      for (let key in cache.answers) {
        if (cache.answers[key] || cache.answers[key] === 0) {
          questCount++;
        }
      }
      if (questCount < totalQuestion.value) {
        ElMessageBox.confirm(`还有${totalQuestion.value - questCount}题未作答，确认交卷吗？`, "", {
          showClose: false,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          finishExamApi(1);
        });
      } else {
        ElMessageBox.confirm(`确认交卷吗？`, "", {
          showClose: false,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          finishExamApi(1);
        });
      }
    } else if (type == 2) {
      finishExamApi(2);
    } else if (type == 3) {
      let questCount = 0;
      for (let key in cache.answers) {
        if (cache.answers[key] || cache.answers[key] === 0) {
          questCount++;
        }
      }
      ElMessageBox.confirm(`本部分提交后不能返回修改${totalQuestion.value - questCount > 0 ? `（还有题${totalQuestion.value - questCount}未作答)` : ""}，确认提交吗？`, "", {
        showClose: false,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        finishExamApi(1, 1);
      });
    }
  }
  function finishExamApi(submit, syncScore) {
    clearInterval(fastCountDownTimer);
    if (countDownTimer) countDownTimer.close();
    countDownTimer = null;
    if (countTimer) clearInterval(countTimer);
    let data = {
      answers: {
        ...cache.answers
      },
      audios: {
        ...cache.audios
      },
      remaining: cache.remaining,
      examId: examId,
      submit: submit,
      syncScore: syncScore ? syncScore : 0
    };
    const loading = ElLoading.service({
      lock: true,
      text: "正在提交考试..",
      background: "rgba(0, 0, 0, 0.7)"
    });
    SubmitExamApi({
      ...data
    }).then(r => {
      if (r.status < 400) {
        ElMessage({
          type: "success",
          showClose: true,
          message: "提交成功"
        });
        setTimeout(() => {
          loading.close();
          if (submit == 1) {
            content.emit("finishExam", r.data);
          } else {
            content.emit("finishExam");
          }
        }, 1000);
      } else {
        loading.close();
        ElMessage({
          type: "error",
          showClose: true,
          message: r.msg
        });
      }
    });
  }
  function setFastCountDown() {
    fastCountDownTimer = setInterval(() => {
      if (fastTime.value <= 0) {
        clearInterval(fastCountDownTimer);
      } else {
        fastTime.value--;
        let min = parseInt(fastTime.value / 60);
        let sec = fastTime.value % 60;
        fastTimeText.value = min > 9 ? min : "0" + min;
        fastTimeText.value += ":";
        fastTimeText.value += sec > 9 ? sec : "0" + sec;
      }
    }, 1000);
  }
  return {
    timeText,
    setCountDown,
    finishExam,
    fastTimeText,
    setFastCountDown
  };
}